.section {
	border: 1px solid #d1d5db;
	border-radius: 12px;
	overflow: hidden;
	margin-bottom: 0.6rem;
	background: #ffffff;
	display: flex;
	flex-direction: column;
	min-height: 100%;
}

.section:last-child {
	margin-bottom: 0;
}

.sectionHeader {
	display: flex;
	align-items: center;
	gap: 0.35rem;
	padding: 0.45rem 0.55rem;
	font-size: 0.74rem;
	font-weight: 700;
	color: #1f2937;
	background: #f3f4f6;
	border-bottom: 1px solid #e5e7eb;
}

.tableShell {
	display: flex;
	flex: 1;
	min-height: 100%;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
}

.tableShell::-webkit-scrollbar {
	height: 6px;
}

.tableShell::-webkit-scrollbar-thumb {
	background: #d1d5db;
	border-radius: 3px;
}

.table {
	width: 100%;
	border-collapse: collapse;
	font-size: 0.75rem;
	table-layout: fixed;
	min-width: 360px;
}

.headerCell {
	padding: 0.45rem 0.5rem;
	text-align: left;
	font-weight: 700;
	font-size: 0.7rem;
	color: #111827;
	background: #f9fafb;
	border-bottom: 1px solid #e5e7eb;
	white-space: nowrap;
}

.numericHeaderCell {
	text-align: right;
}

.bodyCell {
	padding: 0.48rem 0.5rem;
	vertical-align: top;
	border-bottom: 1px solid #e5e7eb;
	height: 100%;
}

.numericBodyCell {
	text-align: right;
}

.productCell {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 0.2rem;
	min-height: 2rem;
	width: 100%;
}

.inventoryCodes {
	display: inline-flex;
	width: fit-content;
	max-width: 100%;
	padding: 0.12rem 0.35rem;
	border-radius: 4px;
	background: #ecfdf5;
	color: #166534;
	font-size: 0.68rem;
	font-weight: 700;
	white-space: normal;
}

.optionRow {
	background: #f8fafc;
}

.optionRow .bodyCell {
	border-bottom: 1px solid #e2e8f0;
	padding-top: 0.32rem;
	padding-bottom: 0.32rem;
}

.optionProductCell {
	padding-left: 1.1rem;
	text-align: left;
}

.optionLine {
	font-size: 0.75rem;
	font-weight: 600;
	color: #475569;
	line-height: 1.3;
	word-break: break-word;
}

.optionPrefix {
	font-weight: 600;
	color: #6b7280;
	margin-right: 0.15rem;
}

.optionMutedCell {
	color: #94a3b8;
	font-size: 0.75rem;
}

.sectionTitleWrap {
	display: flex;
	align-items: center;
	gap: 0.4rem;
}
